import { TypeExpandCollapseMiniWithoutUnresolvableLinksResponse } from 'contentful-types'

import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import ExpandCollapseMini from './ExpandCollapseMini'

const ContentfulExpandCollapseMini = withContentful<TypeExpandCollapseMiniWithoutUnresolvableLinksResponse['fields']>(
  ExpandCollapseMini,
  {
    sysID: (props) => props.sys.id,
    entryTitle: (props) => props.fields.entryTitle,
    spacerContent: (props) => {
      return <BlockRenderer block={props.fields.spacerContent} fieldPath={'.spacerContent'} />
    },
    spacer: (props) => {
      return <BlockRenderer block={props.fields.spacer} fieldPath={'.spacer'} />
    },
    children: (props) => {
      return <BlockRenderer block={props.fields.components} fieldPath={'.components'} />
    },
    richText: (props) => {
      return <BlockRenderer block={props.fields.richText} fieldPath={'.richText'} />
    },
    expandTitle: (props) => props.fields.expandTitle,
    collapseTitle: (props) => props.fields.collapseTitle,
    size: (props) => props.fields.size?.toLowerCase(),
    iconPosition: (props) => props.fields.iconPosition?.toLowerCase(),
  }
)

export default ContentfulExpandCollapseMini
